import { flags } from "../Gallery/imageLinks";

export const COUNTRIES = [
  {
    code: "us",
    name: "United States",
    file: flags.us,
  },
  {
    code: "ca",
    name: "Canada",
    file: flags.canada,
  },
  {
    code: "null",
    name: "Rest of the world",
    file: flags.world,
  },
];
